// Campus photo for /colleges/boston-university: CC BY 3.0, by John Phelan, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABoston_University_Marsh_Chapel%2C_Boston_MA.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/boston-university/; credited under the photo.
const photo = {
    "slug": "boston-university",
    "alt": "Marsh Chapel on Marsh Plaza at Boston University, along Commonwealth Avenue in Boston",
    "src": "/colleges/boston-university/campus-1600.webp",
    "srcSmall": "/colleges/boston-university/campus-800.webp",
    "srcMid": "/colleges/boston-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/boston-university/og.jpg",
    "title": "Boston University Marsh Chapel, Boston MA",
    "author": "John Phelan",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABoston_University_Marsh_Chapel%2C_Boston_MA.jpg",
    "read": "2026-10-01"
};

export default photo;
